import React, { useEffect, useState } from "react";
import ReactImageGallery from "react-image-gallery";
import ReactImageMagnify from "@blacklab/react-image-magnify";
import "react-image-gallery/styles/css/image-gallery.css";
import { CDN_BASE_URL } from "../config";

const ProductGallery = ({
  images,
  currentIndex,
  setCurrentIndex,
}) => {
  const galleryImages = images?.map((item) => ({
    original:  item,
    thumbnail:  item,
  }));

  return (
    <div className="relative lg:p-12">
      {galleryImages.length > 0 && (
        <ReactImageGallery  startIndex={currentIndex} items={galleryImages} />
      )}
    </div>
  );
};

export default ProductGallery;
